export default function getImageLoader({
  size,
  subdomain = 'uploads',
}: {
  size: number
  subdomain?: 'uploads' | 'assets'
}): (options: { src: string }) => string {
  return ({ src }: { src: string }) =>
    src.startsWith('http://localhost')
      ? src
      : `https://${subdomain}.schoolhouse.world/cdn-cgi/image/width=${size}/${src}`
}
